import { goodVibesCollectionPath } from "../../featurePaths.ts";

export const GOOD_VIBES_CREATE_CARD_SEGMENT = "create-card";

export const GOOD_VIBES_EDIT_CARD_SEGMENT = "edit-card/:cardId";

export const GOOD_VIBES_CREATE_CARD_OPENER_ID = "good-vibes-create-card";

export const GOOD_VIBES_CARDS_COUNT_ID = "good-vibes-cards-count";

export const GOOD_VIBES_CARDS_EMPTY_ID = "good-vibes-cards-empty";

export function goodVibesCardsHref(collectionId: string, search: string) {
    return `${goodVibesCollectionPath(collectionId)}${search}`;
}

export function goodVibesCreateCardHref(collectionId: string, search: string) {
    return `${goodVibesCollectionPath(collectionId)}/${GOOD_VIBES_CREATE_CARD_SEGMENT}${search}`;
}

export function goodVibesEditCardHref(collectionId: string, cardId: string, search: string) {
    return `${goodVibesCollectionPath(collectionId)}/edit-card/${encodeURIComponent(cardId)}${search}`;
}

export function goodVibesCardActionsId(cardId: string) {
    return `good-vibes-card-actions-${cardId}`;
}

export function findGoodVibesCardsFocusTarget(cardId: string | undefined) {
    const ids = [cardId && goodVibesCardActionsId(cardId), GOOD_VIBES_CREATE_CARD_OPENER_ID, GOOD_VIBES_CARDS_COUNT_ID, GOOD_VIBES_CARDS_EMPTY_ID];

    for (const id of ids) {
        const element = id ? document.getElementById(id) : null;

        if (element) {
            return element;
        }
    }

    return null;
}
